import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  Renderer2,
} from '@angular/core';
import { SidebarLinkDirective } from './sidebarlink.directive';
import { Router } from '@angular/router';

@Directive({ selector: '[appSidebar]' })
export class SidebarDirective implements OnInit, AfterViewInit {
  private _activeRoute: string;
  public navlinks: Array<SidebarLinkDirective> = [];
  activeLinks: string[] = [];
  protected $wrapper: Element;
  protected innerWidth: any;

  @Output()
  toggleHideSidebar = new EventEmitter();

  constructor(
    private _el: ElementRef,
    private _renderer: Renderer2,
    private _router: Router,
    private _cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this._activeRoute = this._router.url;
    this.innerWidth = window.innerWidth;
  }

  ngAfterViewInit(): void {
    const element: HTMLElement = this._el.nativeElement;
    this.$wrapper = this._renderer.parentNode(this._el.nativeElement); // document.getElementsByClassName("wrapper")[0];

    const sidebarImgContainer = this._el.nativeElement.querySelector(
      '.sidebar-background',
    );
    const sidebarImg = element.getAttribute('data-image');

    if (sidebarImgContainer.length !== 0 && sidebarImg !== undefined) {
      this._renderer.setAttribute(
        sidebarImgContainer,
        'style',
        'background-image: url("' + sidebarImg + '")',
      );
    }

    if (!this.$wrapper.classList.contains('nav-collapsed')) {
      this.expandActive();
    }

    if (this.innerWidth < 992) {
      this._renderer.removeClass(this.$wrapper, 'nav-collapsed');
      this._renderer.removeClass(this.$wrapper, 'menu-collapsed');
      this.toggleHideSidebar.emit(true);
    }

    this._cd.detectChanges();
  }

  @HostListener('mouseenter', ['$event'])
  onMouseOver(): void {
    if (this.$wrapper.classList.contains('nav-collapsed')) {
      this._renderer.removeClass(this.$wrapper, 'menu-collapsed');

      this.navlinks
        .filter((_) => _.navCollapsedOpen === true)
        .forEach((link: SidebarLinkDirective) => {
          link.open = true;
          link.navCollapsedOpen = false;
        });
    }
  }

  @HostListener('mouseleave', ['$event'])
  onMouseOut(): void {
    if (this.$wrapper.classList.contains('nav-collapsed')) {
      this._renderer.addClass(this.$wrapper, 'menu-collapsed');

      this.navlinks
        .filter((_) => _.open === true)
        .forEach((link: SidebarLinkDirective) => {
          link.open = false;
          link.navCollapsedOpen = true;
        });
    }
  }

  @HostListener('click', ['$event'])
  onClick(e: any): void {
    if (
      e.target.parentElement.classList.contains('logo-text') ||
      e.target.parentElement.classList.contains('logo-img')
    ) {
      this.activeLinks = [];
      this._activeRoute = this._router.url;
      this.expandActive();
      this.hideSidebar();
    } else if (
      e.target.parentElement.classList.contains('nav-close') ||
      e.target.classList.contains('nav-close')
    ) {
      this.toggleHideSidebar.emit(true);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;

    if (event.target.innerWidth < 992) {
      this._renderer.removeClass(this.$wrapper, 'nav-collapsed');
      this._renderer.removeClass(this.$wrapper, 'menu-collapsed');
      this.toggleHideSidebar.emit(true);
    }

    if (event.target.innerWidth > 992) {
      const toggleStatus = this._el.nativeElement;
      this._el.nativeElement
        .querySelector('.toggle-icon')
        .getAttribute('data-toggle');

      if (
        toggleStatus === 'collapsed' &&
        this.$wrapper.classList.contains('nav-collapsed') &&
        this.$wrapper.classList.contains('menu-collapsed')
      ) {
        this.$wrapper.classList.add('nav-collapsed');
        this.$wrapper.classList.add('menu-collapsed');
      }

      this.toggleHideSidebar.emit(false);
    }
  }

  // check outside click and close sidebar for smaller screen <992
  @HostListener('document:click', ['$event'])
  onOutsideClick(event): void {
    if (this.innerWidth < 992) {
      let clickedComponent = event.target;
      let inside = false;

      do {
        if (clickedComponent === this._el.nativeElement) {
          inside = true;
        }

        clickedComponent = clickedComponent.parentNode;
      } while (clickedComponent);

      if (
        !this._el.nativeElement.classList.contains('hide-sidebar') &&
        !inside &&
        !event.target.classList.contains('navbar-toggle')
      ) {
        this.toggleHideSidebar.emit(true);
      }
    }
  }

  addLink(link: SidebarLinkDirective): void {
    this.navlinks.push(link);
  }

  getLinks(): SidebarLinkDirective[] {
    return this.navlinks;
  }

  hideSidebar(): void {
    if (this.innerWidth < 992) {
      this.toggleHideSidebar.emit(true);
    }
  }

  expandActive(): void {
    this.navlinks
      .filter((_) => _.routePath === this._activeRoute)
      .forEach((link: SidebarLinkDirective) => {
        link.isShown = true;

        if (link.level.toString().trim() === '3') {
          this.navlinks
            .filter(
              (_) =>
                _.level.toString().trim() === '2' && _.title === link.parent,
            )
            .forEach((parentLink: SidebarLinkDirective) => {
              parentLink.open = true;
              this.activeLinks.push(parentLink.title);
              this.navlinks
                .filter(
                  (_) =>
                    _.level.toString().trim() === '1' &&
                    _.title === parentLink.parent,
                )
                .forEach((superParentLink: SidebarLinkDirective) => {
                  superParentLink.open = true;
                  this.activeLinks.push(superParentLink.title);
                  superParentLink.toggleEmit.emit(this.activeLinks);
                });
            });
        } else if (link.level.toString().trim() === '2') {
          this.navlinks
            .filter(
              (_) =>
                _.level.toString().trim() === '1' && _.title === link.parent,
            )
            .forEach((parentLink: SidebarLinkDirective) => {
              parentLink.open = true;
              this.activeLinks.push(parentLink.title);
              parentLink.toggleEmit.emit(this.activeLinks);
            });
        }
      });
  }

  toggleActiveList(): void {
    this.navlinks
      .filter(
        (_) =>
          _.level.toString().trim() === '3' &&
          _.routePath !== this._activeRoute,
      )
      .forEach((link: SidebarLinkDirective) => {
        link.active = false;
      });
  }

  setIsShown(parentLink: SidebarLinkDirective): void {
    const childLevel = Number(parentLink.level) + 1;
    this.navlinks
      .filter(
        (_) =>
          _.level.toString().trim() === childLevel.toString().trim() &&
          _.parent === parentLink.title,
      )
      .forEach((link: SidebarLinkDirective) => {
        link.isShown = true;
        link.isHidden = false;
      });
  }

  setIsHidden(parentLink: SidebarLinkDirective): void {
    const childLevel = Number(parentLink.level) + 1;
    this.navlinks
      .filter(
        (_) =>
          _.level.toString().trim() === childLevel.toString().trim() &&
          _.parent === parentLink.title,
      )
      .forEach((link: SidebarLinkDirective) => {
        link.isShown = false;
        link.isHidden = true;
      });
  }
}
